// extracted by mini-css-extract-plugin
module.exports = {"text_area":"text-area_text_area__uMQMl","disabled":"text-area_disabled__2yGYj"};